import React from "react";
import {
  getVetDomainsDisplay,
  VET_DOMAINS_ICON_SRC,
  VET_DOMAINS_ICON_CLASS,
} from "../utils/vetDomainsDisplay.js";

export default function VetDomainsTypeLabel({
  classification,
  tx = null,
  leading = null,
  className = "",
}) {
  const display = getVetDomainsDisplay(classification, tx);
  if (!display) return null;

  return (
    <span
      className={`inline-flex min-w-0 items-start gap-2 text-left font-semibold text-blue-600 ${className}`}
    >
      {leading ? (
        <span className="mt-0.5 flex-shrink-0" aria-hidden="true">
          {leading}
        </span>
      ) : null}
      <img
        src={VET_DOMAINS_ICON_SRC}
        alt="vet.domains"
        className={VET_DOMAINS_ICON_CLASS}
        loading="lazy"
        decoding="async"
        draggable={false}
        onError={(event) => {
          event.currentTarget.style.display = "none";
        }}
      />
      <span className="min-w-0 leading-tight">
        <span className="block whitespace-normal break-words">
          {display.title}
        </span>
        <span className="block whitespace-normal break-words text-[11px] font-medium text-blue-700/90">
          {display.subtitle}
        </span>
      </span>
    </span>
  );
}
